import styled from 'styled-components';

export const StyledFlexDiv = styled.div`
  display: flex;
`;
